<template>
  <section class="section columns">
    <div class="box column container is-four-fifths">
      <h1 class="box title forum-name is-4">{{forum.name}}</h1>
      <div
        :id="'topic' +topic.id"
        class="box topic-container"
        v-for="(topic, i) in Topics"
        :key="i"
      >
        <div class="level">
          <div class="level-left topic-title-box">
            <h2
              @click.prevent="$store.dispatch('closeTopic',topic.id)"
              class="subtitle is-4 has-text-left topic-name"
            >{{topic.name}}</h2>
          </div>
          <div class="level-right plus" @click.prevent="showModal(i)">
            <span class="level-item icon is-medium">
              <svg aria-hidden="true" focusable="false">
                <use xlink:href="../assets/img/icons/plus-square.svg#plus" />
              </svg>
            </span>
          </div>
          <div class="modal" ref="newPost">
            <div class="modal-background" @click.prevent="hideModal(i)"></div>
            <div class="modal-content">
              <div class="field">
                <div class="control">
                  <input
                    v-model="title"
                    type="text"
                    placeholder="Post Title..."
                    class="input wrong-ready"
                    :class="{'is-danger':wrongInput}"
                  />
                </div>
                <div class="control">
                  <textarea
                    type="text"
                    v-model="content"
                    placeholder="Post Content..."
                    class="textarea wrong-ready"
                    :class="{'is-danger':wrongInput}"
                  ></textarea>
                </div>
                <div class="field is-grouped">
                  <div class="control">
                    <button
                      class="button is-link"
                      @click.prevent="createPost(topic.id, $store.state.auth.user.id, i,forum.id)"
                    >Submit</button>
                  </div>
                </div>
              </div>
            </div>
            <button @click.prevent="hideModal(i)" class="modal-close is-large" aria-label="close"></button>
          </div>
        </div>
        <a
          @click="showPosts(forum.id,topic.id); $store.dispatch('openTopic',topic.id)"
          v-show="!$store.state.forum.openTopics.includes(topic.id)"
        >Show posts...</a>

        <div
          v-if="loadedTopicsId.includes(topic.id) && $store.state.forum.openTopics.includes(topic.id)"
        >
          <div
            v-for="(post, k) in loadedTopics[topic.id].posts.slice().reverse()"
            :key="k"
            class="box post"
          >
            <article class="media">
              <div class="media-left">
                <figure class="image is-64x64">
                  <img :src="post.posted_by.profile_image" alt="Image" />
                </figure>
              </div>

              <div class="media-content level">
                <div class="content level-left">
                  <p>
                    <a
                      @click.prevent="gotoPost(forum.id,topic.id,post.id)"
                      class="subtitle is-5 post-name"
                    >{{post.title}}</a>
                    <br />
                    <strong>{{post.posted_by.full_name}}</strong>
                    <span v-if="post.posted_by.roles == 'mentor'" class="mentor">Mentor</span>
                    <span
                      v-if="post.posted_by.roles == 'project-leader'"
                      class="project-leader"
                    >Project Leader</span>
                    <small>{{dateFormat(post.created_at.date)}}</small>
                  </p>
                </div>
                <div class="level-right">
                  <button
                    v-if="$store.state.auth.user.is_admin || $store.state.auth.user.id == post.posted_by.id"
                    class="button delete-button"
                    @click.prevent="showDeleteModal(forum.id,topic.id,post.id)"
                  >Delete</button>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      <div class="modal" ref="deletePost">
        <div class="modal-background" @click.prevent="hideDeleteModal"></div>
        <div class="modal-content section box">
          <div
            class="has-text is-size-3 delete-text has-text-centered"
          >Are you sure you would like to delete?</div>
          <div class="field is-grouped delete-buttons">
            <div class="control">
              <button class="button is-link" @click.prevent="hideDeleteModal">Cancel</button>
            </div>
            <div class="control">
              <button class="button is-text" @click.prevent="deletePost(postToDelete)">Confirm</button>
            </div>
          </div>
        </div>
        <button @click.prevent="hideDeleteModal" class="modal-close is-large" aria-label="close"></button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import BaseHelper from "../helpers/BaseHelper";
import { ForumClient } from "../clients/ForumClient.js";
import { setTimeout } from "timers";
import { log } from "util";

export default {
  name: "Forum",
  props: ["forumId"],
  computed: {
    ...mapState({
      forum(state) {
        return state.forum.forum;
      },
      Topics(state) {
        let normTopics = state.forum.forum.topics;
        if (state.forum.forum.topics) {
          return normTopics.slice().reverse();
        } else {
          return normTopics;
        }
      },
      loadedTopicsId(state) {
        return state.forum.loadedTopics;
      },
      loadedTopics(state) {
        return state.forum.topics;
      },
      navigate(state) {
        return state.search.navigate;
      },
      hasLoaded(state) {
        return state.forum.hasLoaded;
      }
    })
  },
  data() {
    return {
      content: "",
      title: "",
      postToDelete: "",
      wrongInput: false
    };
  },

  mixins: [BaseHelper],
  watch: {
    hasLoaded() {
      if (this.navigate == true && this.hasLoaded == true) {
        console.log("loaded fired");
        this.gototopic();
      }
    },
    navigate() {
      if (this.navigate == true) {
        console.log("navigate fired");

        this.gototopic();
      }
    }
  },
  methods: {
    gototopic() {
      if (this.hasLoaded == true) {
        if (this.$store.state.search.topicId != null) {
          document
            .querySelector("#topic" + this.$store.state.search.topicId)
            .scrollIntoView({
              behavior: "smooth"
            });
          this.$store.dispatch("search/setTargetTopic", null);
          this.$store.dispatch("search/setNavigate", false);
        } else {
          this.$store.dispatch("search/setTargetTopic", null);
          this.$store.dispatch("search/setNavigate", false);
        }
      }
    },
    showPosts(forumId, topicId) {
      this.$store.dispatch("getTopic", { forumId: forumId, topicId: topicId });
    },
    deletePost(postToDelete) {
      ForumClient.deletePost(postToDelete.postId)
        .then(response => {
          this.hideDeleteModal();
          this.$store.dispatch("GET_FORUM", this.forumId);
          this.$store.dispatch("getTopic", {
            forumId: postToDelete.forumId,
            topicId: postToDelete.topicId
          });
          this.postToDelete = "";
        })
        .catch(error => console.log(error));
    },
    hideDeleteModal() {
      this.$refs.deletePost.classList.remove("is-active");
    },
    showDeleteModal(forumId, topicId, postId) {
      this.postToDelete = {
        forumId: forumId,
        topicId: topicId,
        postId: postId
      };
      this.$refs.deletePost.classList.add("is-active");
    },
    createPost(topicId, userId, sectionId, forumId) {
      if (this.content.length > 1 && this.title.length > 1) {
        let payload = {
          content: this.content,
          title: this.title,
          topicId: topicId,
          userId: userId
        };
        ForumClient.createPost(payload)
          .then(response => {
            this.content = "";
            this.title = "";
            this.$store.dispatch("getTopic", {
              forumId: forumId,
              topicId: topicId
            });
            console.log(response);
            this.hideModal(sectionId);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.wrongInput = true;
        setTimeout(() => {
          this.wrongInput = false;
        }, 600);
      }
    },
    showModal(id) {
      this.$refs.newPost[id].classList.add("is-active");
    },
    hideModal(id) {
      this.$refs.newPost[id].classList.remove("is-active");
    },

    dateFormat(date) {
      return " @" + this.$moment(date).format("dddd, D MMMM YYYY, HH:mm");
    }
  },
  mounted() {
    this.$store.dispatch("GET_FORUM", this.forumId);
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";
@import "../assets/scss/forum.scss";
</style>


